import React from 'react';
import Modal from '../../components/Modal/Modal';
import SelectCustom from '../../components/Select/SelectCustom';
import Loader from '../../components/Loader/Loader';
import useSelectAgentModal from './useSelectAgentModal';


const SelectAgentModal = ({openModal , setOpenModal}) => {

    const { 
        modalAction,
        allAgentNames,
        selectedAgent,
        loading
    } = useSelectAgentModal(openModal , setOpenModal);

    return(
        <Modal
            isOpen={openModal}
            title={'Select Agents'}
            onModalClose={modalAction.onClose}
            onModalSubmit={modalAction.onSubmit}
        >
            <>
                {loading ?
                    <Loader></Loader>

                    :
                    <SelectCustom
                        label="Agent names"
                        options={allAgentNames ? allAgentNames : []}
                        value={selectedAgent ? selectedAgent : ''}
                        setValue={val => modalAction.onAgentSelected(val)}
                    />
                }
            </>
        </Modal>
    )
}

export default SelectAgentModal;